import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

export default function Footer() {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    product: [
      { label: 'Stories Library', href: '/stories-library' },
      { label: 'Download App', href: '/app-download' },
      { label: 'Premium Plans', href: '/app-download' },
      { label: 'Gift Cards', href: '/app-download' },
    ],
    community: [
      { label: 'Creator Community', href: '/creator-community' },
      { label: 'Become a Creator', href: '/creator-community' },
      { label: 'Regional Hubs', href: '/regional-hubs' },
      { label: 'Events', href: '/about-us' },
    ],
    company: [
      { label: 'About Us', href: '/about-us' },
      { label: 'Careers', href: '/about-us' },
      { label: 'Press Kit', href: '/about-us' },
      { label: 'Contact', href: '/about-us' },
    ],
    legal: [
      { label: 'Privacy Policy', href: '/about-us' },
      { label: 'Terms of Service', href: '/about-us' },
      { label: 'Content Guidelines', href: '/about-us' },
      { label: 'Cookie Policy', href: '/about-us' },
    ],
  };

  const socialLinks = [
    { icon: 'facebook', href: '#', label: 'Facebook' },
    { icon: 'twitter', href: '#', label: 'Twitter' },
    { icon: 'instagram', href: '#', label: 'Instagram' },
    { icon: 'youtube', href: '#', label: 'YouTube' },
  ];

  return (
    <footer className="bg-gradient-to-br from-primary-dark to-primary text-white">
      <div className="container mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-8 mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center">
                <AppImage
                  src="/assets/images/image-1767859099901.png"
                  alt="StoryNest-FM Logo"
                  width={48}
                  height={48}
                  className="w-12 h-12 object-contain"
                />
              </div>
              <span className="text-xl font-heading font-bold">StoryNest-FM</span>
            </div>
            <p className="text-white/80 mb-6 max-w-sm">
              India's premier audio storytelling platform. Discover, listen, and share stories in 18+ Indian languages.
            </p>
            <div className="flex items-center space-x-4">
              {socialLinks?.map((social) => (
                <a
                  key={social?.icon}
                  href={social?.href}
                  aria-label={social?.label}
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
                >
                  <Icon name="ShareIcon" size={20} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading font-bold text-lg mb-4">Product</h3>
            <ul className="space-y-2">
              {footerLinks?.product?.map((link) => (
                <li key={link?.label}>
                  <a
                    href={link?.href}
                    className="text-white/80 hover:text-white transition-colors"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-bold text-lg mb-4">Community</h3>
            <ul className="space-y-2">
              {footerLinks?.community?.map((link) => (
                <li key={link?.label}>
                  <a
                    href={link?.href}
                    className="text-white/80 hover:text-white transition-colors"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-bold text-lg mb-4">Company</h3>
            <ul className="space-y-2">
              {footerLinks?.company?.map((link) => (
                <li key={link?.label}>
                  <a
                    href={link?.href}
                    className="text-white/80 hover:text-white transition-colors"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-bold text-lg mb-4">Legal</h3>
            <ul className="space-y-2">
              {footerLinks?.legal?.map((link) => (
                <li key={link?.label}>
                  <a
                    href={link?.href}
                    className="text-white/80 hover:text-white transition-colors"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-white/80 text-sm">
              © {currentYear} StoryNest-FM. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 text-sm text-white/80">
              <span>Made with ❤️ in India</span>
              <span>•</span>
              <span>Available in 18+ Languages</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}